import type { ReaderPreferences, ArabicFontFamily } from './types'

export type ProfilePreferences = {
  defaultTranslation?: string
  defaultReciter?: string
  arabicFont?: ArabicFontFamily
  fontSize?: number
  translationEnabled?: boolean
  kidMode?: boolean
}

export function adaptToProfile(p: ReaderPreferences): ProfilePreferences {
  return {
    defaultTranslation: p.edition,
    defaultReciter: p.reciter,
    arabicFont: p.arabicFont,
    fontSize: p.fontSize,
    translationEnabled: p.showTranslation,
    // kidMode is intentionally NOT sent through PUT /profile. The server
    // rejects the field outright (BAD_REQUEST) — kidMode transitions are
    // owned by /family/pin (set + enable) and /family/pin/verify (verify
    // + disable), so the gate is never in a "half-set" state. If we sent
    // it here too, the profile sync would fail every time the local mirror
    // updates after a family endpoint succeeds.
    // wbwEnabled intentionally omitted — local-only.
  }
}

export function adaptFromProfile(p: ProfilePreferences | undefined): Partial<ReaderPreferences> {
  if (!p) return {}
  const out: Partial<ReaderPreferences> = {}
  if (p.arabicFont) out.arabicFont = p.arabicFont
  if (typeof p.fontSize === 'number') out.fontSize = p.fontSize
  if (p.defaultReciter) out.reciter = p.defaultReciter
  if (p.defaultTranslation) out.edition = p.defaultTranslation
  if (typeof p.translationEnabled === 'boolean') out.showTranslation = p.translationEnabled
  if (typeof p.kidMode === 'boolean') out.kidMode = p.kidMode
  return out
}
